import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

ReactDOM.render(
  <>
    <h1>
      Cellular Automata / Maze 
    </h1>
    <div>
      <App />
    </div>
    <h3>
      <a href="https://github.com/ryan-kanghyun-moon/Cellular-Automata-App">visit this repo</a>
      {" and "} 
      <a href="https://ryan-kanghyun-moon.github.io/resume/">my website</a>
    </h3>
  </>,
  document.getElementById('root')
);
